/**
 * Vue « Listes » de la page Transporteurs (prospects, exploitation, listes issues du sourcing).
 * Elle s'ouvre sur /carriers?vue=listes : plus de page ni d'entrée de menu à part.
 */

/** Paramètre d'URL qui choisit la vue de la page Transporteurs. */
export const VIEW_PARAM = 'vue';

/** Valeur du paramètre pour la vue Listes. */
export const LISTS_VIEW = 'listes';

/** Adresse de la vue Listes, sans filtre. */
export const CARRIER_LISTS_URL = `/carriers?${VIEW_PARAM}=${LISTS_VIEW}`;

/** Vrai si l'URL (chemin + query) est la vue Listes, quels que soient la liste choisie et la recherche. */
export function isCarrierListsUrl(url: string): boolean {
  try {
    const parsed = new URL(url, 'http://local');
    return parsed.pathname === '/carriers' && parsed.searchParams.get(VIEW_PARAM) === LISTS_VIEW;
  } catch {
    return false;
  }
}
